import { createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useTemplateStyles = makeStyles(() =>
  createStyles({
    createTicketTemplate: {
      background: 'transparent',
      marginTop: '10px',
      minHeight: '300px',
      minWidth: '300px',
      '& > * > * textarea': {
        height: '100%'
      }
    }
  })
);
